import { render, staticRenderFns } from "./PreviewFiles.vue?vue&type=template&id=4df2dc0a&scoped=true&"
import script from "./PreviewFiles.vue?vue&type=script&lang=js&"
export * from "./PreviewFiles.vue?vue&type=script&lang=js&"
import style0 from "./PreviewFiles.vue?vue&type=style&index=0&id=4df2dc0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df2dc0a",
  null
  
)

export default component.exports